import React from "react";
import "./Projects.css";
import covid from "../../assests/covid.png";
import TextUtils from "../../assests/TextUtils.png";
import CSS from "../../assests/CSS.png";

const data = [
  {
    id: 1,
    image: covid,
    title: "Covid-19 Tracker",
    github: "https://github.com/sharmil01/covid19Tracker",
    demo: "https://sharmil01.github.io/covid19Tracker/",
  },
  {
    id: 2,
    image: TextUtils,
    title: "TextUltis - Word Manipulator",
    github: "https://github.com/sharmil01/TextUtils",
    demo: "https://sharmil-macwan.netlify.app/",
  },
  {
    id: 3,
    image: CSS,
    title: "CSS-Tricks",
    github: "https://github.com/sharmil01/CSS-Tricks",
    demo: "https://github.com/sharmil01/CSS-Tricks",
  },
];

const Projects = () => {
  return (
    <section id="projects">
      <h5>My Recent Work</h5>
      <h2>Projects</h2>
      <div className="container Projects__container">
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className="Projects__item">
              <div className="Projects__item-image">
                <img src={image} alt={title}></img>
              </div>
              <h3>{title}</h3>
              <div className="Projects__item-cta">
                <a href={github} className="btn" target="_blank">
                  Github
                </a>
                <a href={demo} className="btn btn-primary" target="_blank">
                  Live Demo
                </a>
              </div>
            </article>
          );
        })}
      </div>
    </section>
  );
};

export default Projects;
